import { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import config from "src/config/config";
import { theme } from "styled-tools";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';
import { Link } from "react-router-dom";

function TowerRushJackpotPromo(props: any) {
    const { theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>
            <InformationWrapper>
                <h1>Climb Higher. Bet Bigger. Win the Ultimate Jackpot.</h1>
                <p className="top-para">
                    Get ready for the Tower Rush Jackpot! Place your bets on Tower Rush during the promotion period for a <br /> chance to win a massive cash prize.
                    <br /><br />
                    Promotion Period: <strong>1 September - 31 October 2026</strong>
                </p>

                <ImageWrapper className="GTRCard">
                    <Link to="/instant-games/tower-rush">
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.GTRInnerCard}`}
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </Link>
                </ImageWrapper>

                <h2>How to Claim</h2>
                <ImageWrapper>
                    <LazyLoadImage
                        src={`${config.imageV3Host}/static/cashsite/${theme.image.GTRSteps}`}
                        effect="none"
                        placeholder={<PlaceholderImage />}
                    />
                </ImageWrapper>

                <h2>Terms & Conditions</h2>
                <TermsList>
                    <li>Promotion is valid from <strong>1 September to 31 October 2026</strong></li>
                    <li>Players must place a minimum of <strong>50 qualifying bets</strong> on Tower Rush 
    during the promotion period.</li>
                    <li>Only qualifying bets placed during the promotion period will count. </li>
                    <li>The Jackpot prize is <strong>₹30,00,000 (30 Lakhs)</strong></li>
                    <li>The prize will be credited to the eligible winner's wallet.</li>
                    <li>Players must have a valid and active account to participate.</li>
                    <li>Cancelled, voided or invalid bets will not count towards the 
    promotion.</li>
                    <li>Regular Terms & Conditions apply.</li>
                </TermsList>
            </InformationWrapper>
        </>
    );
}

export default withTheme(withAppContext(TowerRushJackpotPromo));

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 2rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.GTRInnerBG")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    position: relative;
    gap: 2rem;

    h1, h2, p {
        margin: 0;
        padding: 0;
    }

    h1, h2 {
        width: 100%;
        color: #FDE102;
        text-align: center;
        font-style: normal;
        font-weight: 700;
        font-family: 'Inter-Bold';
        line-height: normal;
    }

    h1 {
        font-size: 22px;
        text-transform: capitalize;
    }

    h2 {
        font-size: 20px;
        text-transform: capitalize;
    }

    .top-para {
        width: 100%;
        color: #FFF;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 35px;
        text-transform: none;
    }

    .GTRCard {
        & span {
            display: flex !important;
            justify-content: center !important;
            img {
                width: 60%;
            } 
        }
    }
`;


const ImageWrapper = styled.div`
    width: 65%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(7px);
    
    img {
        width: 100%;
    }
`;

const TermsList = styled.ul`
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
    margin: 0 auto;
    padding: 0;
    list-style: none;

    li {
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        text-align: left;
        font-weight: 400;
        line-height: 27px;
        text-transform: capitalize;
        background: #707070;
        padding: 12px 1.5rem 12px 2.5rem;
        position: relative;
    }

    li::before {
        content: "✦";
        position: absolute;
        color: #fff;
        left: 1.5rem;
        top: 12px;
    }
`;